<template>
  <div class="login-contain">
    <div class="center-box">
      <div class="left">
        <img src="@/assets/icon/logo.png" class="logo">
        <div>ATK 后台管理系统</div>
      </div>
      <div class="right">
        <div class="title">欢迎登陆</div>
        <el-form ref="loginForm" :model="loginForm" label-width="0px" :rules="rules">
          <el-form-item prop="account">
            <el-input prefix-icon="el-icon-user" v-model="loginForm.account"
                      placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input prefix-icon="el-icon-lock" v-model="loginForm.password" show-password
                      placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="login-btn" style="margin-top: 20px;" @click="loginSubmit">立即登录</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  components: {},
  props: {},
  data () {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入账户', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  created () { },
  mounted () { },
  methods: {
    async loginSubmit () {
      try {
        await this.$refs.loginForm.validate()
        console.log('提交', this.loginForm)
        this.$callApi("login", this.loginForm)
        .then(res=>{
          this.$message.success('登录成功')
          this.$emit('success')
        })
        .catch(e=>{
          console.log(this.$message)
          this.$message.error('登录失败')
        })

      } catch (error) {

      }
    }
  },
}
</script>
<style lang="less" scoped>
.login-contain {
  height: 100vh;
  width: 100vw;
  /* 设置背景图片 */
  background-image: url('../../assets/images/login/空间站宇宙航天.jpg');
  background-size: 100% auto; /* 控制背景图片的大小 */
  background-position: center; /* 控制背景图片的位置 */
  background-repeat: no-repeat; /* 不重复背景图片 */
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 设置半透明黑色背景 */
.login-contain::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 4, 9, 0.2);
}
.center-box {
  z-index: 999;
  height: max-content;
  display: flex;
  font-size: 20px;
  border-radius: 5px;
  overflow: hidden;
  .left {
    min-height: 100%;
    max-height: 100%;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(29, 33, 49, 0.75);
    color: #fff;
    opacity: 0.95;
    .logo {
      margin-bottom: 10px;
      width: 50px;
    }
  }
  .right {
    height: 100%;
    width: 350px;
    background-color: #fcfdff;
    padding: 20px 40px;
    .title {
      margin-bottom: 30px;
      text-align: center;
      color: #555;
      font-weight: bold;
    }
    .login-btn {
      background-color: #2761f6;
      border-radius: 50px;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
  }
}
/deep/.el-input__inner {
  background-color: #f4f7ff;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/login/login.vue